import APIService from './APIService';

export default {
  getExportacoes() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/exportacoes-bdgds/index')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },

  save(postData) {
    return APIService.apiCall().post('/exportacoes-bdgds/save', JSON.stringify(postData));
  },

  getDatesAndRegistersImportedEntities() {
    return APIService.apiCall().get('/exportacoes-bdgds/getDatesAndRegistersImportedEntities');
  },

  getImportedEntitiesAndRegistersByDate(date, companyId, bdgdVersionId) {
    return APIService.apiCall().get(
      `/exportacoes-bdgds/getImportedEntitiesAndRegistersByDate/${date}/${companyId}/${bdgdVersionId}`
    );
  },

  getUrlDownload(id) {
    return APIService.apiCall().get(`/exportacoes-bdgds/baixar-arquivo-resultado/${id}`);
  }
};
